import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { forkJoin } from 'rxjs';
import { ErsCasesComponent } from './../../pages/dashboard/case-management/ers-cases/ers-cases.component';
import { CaseManagementService } from './../../services/caseManagement.service';
import { CommonService } from './../../services/common.service';

@Component({
  selector: 'ngx-customer-hierarchy',
  templateUrl: './customer-hierarchy.component.html',
  styleUrls: ['./customer-hierarchy.component.css'],
})
export class CustomerHierarchyComponent implements OnInit {

  @ViewChild(ErsCasesComponent, { static: false }) ersCasesComponent;
  @Input() loadDashboardData = false;
  companyName: any;
  customerKey: any;
  subCustomerId: any = [];
  subCustomerKey: any = [];
  divisionId: any = [];
  locationId: any = [];
  hierarchy: any;
  regionData: any;
  divisionData: any;
  locationData: any;
  disableRegion: boolean = false;
  disableDivision: boolean = false;
  disableLocation: boolean = false;
  loading: boolean = false;
  dropdownList = [];
  selectedItems = [];
  regionDropdownSettings: IDropdownSettings;
  divisionDropdownSettings: IDropdownSettings;
  locationDropdownSettings: IDropdownSettings;
  pageLoad: boolean = false;

  constructor(
    private caseManagementService: CaseManagementService,
    private commonService: CommonService,
  ) { }

  ngOnInit(): void {
    this.pageLoad = true;
    sessionStorage.removeItem('hierarchySubCustomerKey');
    sessionStorage.removeItem('hierarchyDivisionId');
    sessionStorage.removeItem('hierarchyLocationId');

    this.commonService.dashboardRefresh.subscribe(() => {
      this.setHierarchyData();
    });

    this.companyName = sessionStorage.getItem('companyName');
    this.customerKey = sessionStorage.getItem('legacyCustomerKeyId');
    this.hierarchy = sessionStorage.getItem('hierachy');

    if (sessionStorage.getItem('ersSubcustomerId') !== '0') {
      this.subCustomerKey.push(sessionStorage.getItem('ersSubcustomerId'));
      sessionStorage.setItem('hierarchySubCustomerKey', sessionStorage.getItem('ersSubcustomerId'));
    }
    if (sessionStorage.getItem('fleetSubcustomerId') !== '0') {
      this.subCustomerId.push(sessionStorage.getItem('fleetSubcustomerId'));
    }
    if (sessionStorage.getItem('fleetDivisionId') !== '0') {
      this.divisionId.push(sessionStorage.getItem('fleetDivisionId'));
      sessionStorage.setItem('hierarchyDivisionId', sessionStorage.getItem('fleetDivisionId'));
    }
    if (sessionStorage.getItem('fleetLocationId') !== '0') {
      this.locationId.push(sessionStorage.getItem('fleetLocationId'));
      sessionStorage.setItem('hierarchyLocationId', sessionStorage.getItem('fleetLocationId'));
    }
    if (this.hierarchy === 'Region' || this.hierarchy === 'Division' || this.hierarchy === 'Location') {
      this.disableRegion = true;
    }
    if (this.hierarchy === 'Division' || this.hierarchy === 'Location') {
      this.disableDivision = true;
    }
    if (this.hierarchy === 'Location') {
      this.disableLocation = true;
    }

    this.getCompanyRegion();

    this.regionDropdownSettings = {
      singleSelection: false,
      idField: 'customerId',
      textField: 'customerName',
      selectAllText: 'Select All Regions',
      unSelectAllText: 'UnSelect All Regions',
      itemsShowLimit: 1,
      allowSearchFilter: false,
    };

    this.divisionDropdownSettings = {
      singleSelection: false,
      idField: 'divisionId',
      textField: 'divisionName',
      selectAllText: 'Select All Divisions',
      unSelectAllText: 'UnSelect All Divisions',
      itemsShowLimit: 1,
      allowSearchFilter: false,
    };

    this.locationDropdownSettings = {
      singleSelection: false,
      idField: 'locationId',
      textField: 'locationName',
      selectAllText: 'Select All Locations',
      unSelectAllText: 'UnSelect All Locations',
      itemsShowLimit: 1,
      allowSearchFilter: false,
    };
  }

  onSelectAllRegions(items: any) {
    this.subCustomerId = items;
    this.displayRegionDetails();
  }

  onSelectAllDivisios(items: any) {
    if (items.length === 0) {
      this.divisionId = [];
    } else {
      this.divisionId = items;
    }

    this.displayDivisionDetails();
  }

  onSelectAllLocations(items: any) {
    this.locationId = items;
    this.displayLocationDetails();
  }

  getCompanyRegion() {
    this.loading = true;
    this.caseManagementService.getCompanyRegion(this.customerKey).subscribe((res: any) => {
      this.loading = false;
      this.regionData = res;
      this.regionData.forEach(region => {
        this.subCustomerKey.push(region.customerKey);
      });
      this.getCompanyDivision(this.customerKey, this.subCustomerKey, this.hierarchy);
    });
  }

  getCompanyDivision(customerKey, subCustomerKey, hierarchy) {
    const data = {
      customerId: customerKey,
      subCustomerId: subCustomerKey.length <= 0 ? '0' : subCustomerKey.toString(),
      hierarchyType: hierarchy,
    };
    this.loading = true;
    this.caseManagementService.getCompanyDivision(data).subscribe((res: any) => {
      this.loading = false;
      this.divisionData = res;
      const hierarchyDivisionId = this.divisionData.map(function (item) {
        return item.divisionId;
      });

      if (subCustomerKey.length === 0) {
        this.getCompanyLocation(this.customerKey, subCustomerKey, hierarchyDivisionId.toString(), this.hierarchy);
      } else {
        this.getCompanyLocation(this.customerKey, subCustomerKey, hierarchyDivisionId.toString(), 'Division');
      }
    });
  }

  getCompanyLocation(customerKey, subCustomerKey, divisionId, hierarchy) {
    const data = {
      customerKey: customerKey,
      subCustomerKey: subCustomerKey.length <= 0 ? '0' : subCustomerKey.toString(),
      divisionId: divisionId.length <= 0 ? '0' : divisionId.toString(),
      hierarchyType: hierarchy,
    };
    this.loading = true;
    this.caseManagementService.getCompanyLocation(data).subscribe((res: any) => {
      this.loading = false;
      this.locationData = res;
      if (this.pageLoad) {
        this.pageLoad = false;
      } else {
        if (this.loadDashboardData) {
          this.setHierarchyData();
        }
      }
    });
  }

  displayRegionDetails() {
    this.divisionId = [];
    this.locationId = [];
    this.subCustomerKey = [];
    this.regionData.forEach(region => {
      if (this.subCustomerId.some(subCustomer => subCustomer.customerId === region.customerId)) {
        this.subCustomerKey.push(region.customerKey);
      }
    });

    sessionStorage.setItem('hierarchySubCustomerKey', this.subCustomerKey.length <= 0 ? '0' : this.subCustomerKey.toString());

    if (this.subCustomerKey.length === 0) {
      this.getCompanyDivision(this.customerKey, this.subCustomerKey, this.hierarchy);
    } else {
      this.getCompanyDivision(this.customerKey, this.subCustomerKey, 'Region');
    }
  }

  displayDivisionDetails() {
    this.locationId = [];
    const selectedDivisions = [];
    this.divisionId.forEach(division => {
      selectedDivisions.push(division.divisionId);
    });

    sessionStorage.setItem('hierarchyDivisionId', selectedDivisions.length <= 0 ? '0' : selectedDivisions.toString());

    if (selectedDivisions.length === 0) {
      this.getCompanyLocation(this.customerKey, this.subCustomerKey, selectedDivisions, this.hierarchy);
    } else {
      this.getCompanyLocation(this.customerKey, this.subCustomerKey, selectedDivisions, 'Division');
    }
  }

  displayLocationDetails() {
    const selectedLocations = [];
    this.locationId.forEach(location => {
      selectedLocations.push(location.locationId);
    });
    sessionStorage.setItem('hierarchyLocationId', selectedLocations.length <= 0 ? '0' : selectedLocations.toString());
    if (this.loadDashboardData) {
      this.setHierarchyData();
    }
  }

  setHierarchyData() {
    if (sessionStorage.getItem('hierarchySubCustomerKey') === undefined ||
      sessionStorage.getItem('hierarchySubCustomerKey') == null) {
      sessionStorage.setItem('hierarchySubCustomerKey', '0');
    }
    if (sessionStorage.getItem('hierarchyDivisionId') === undefined ||
      sessionStorage.getItem('hierarchyDivisionId') == null) {
      sessionStorage.setItem('hierarchyDivisionId', '0');
    }
    if (sessionStorage.getItem('hierarchyLocationId') === undefined ||
      sessionStorage.getItem('hierarchyLocationId') == null) {
      sessionStorage.setItem('hierarchyLocationId', '0');
    }

    this.commonService.setRoCounts();
    this.commonService.setmatrixValue();
    this.commonService.setWOStatusForNewDashBoardCustomerView();
  }

}
